module.exports = __webpack_public_path__ + "static/media/mobile.74367849.svg";